import { useState, useRef, useEffect } from "react";

import styles from './dateAndDes.module.css';

import { DestinationSuggestions } from "../desSuggestions/desSuggestions";

import { TripCalendar } from "../../calendar/calenderCom";


// 📅 Calendar Component for Trip Dates







export const DestinationAndCalendarCom = (props) => {


    const destinationInputRef = useRef(null);
    const dateInputRef = useRef(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [destinationOpen, setDestinationOpen] = useState(false);
    const [dateIsPlaceholder, setDateIsPlaceholder] = useState(props.fakeDate ?? true);

    const formatDate = (date) => {
        if (!date) return '';

        const options = { month: 'short', day: 'numeric' };
        return new Intl.DateTimeFormat('en-US', options).format(date);
    };



    useEffect(() => {
        if (!destinationOpen) return;

        const handleClick = (e) => {
            if (!destinationInputRef.current?.contains(e.target)) {
                setDestinationOpen(false);
            }
        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [destinationOpen]);

    useEffect(() => {

        if (showCalendar && dateInputRef.current) {

            dateInputRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showCalendar]);

    return (

        <>
        
            <div className={
                props.type === 'create' ? ` ${styles.inputGroup} ${styles.inputGroupSuggestions} ${destinationOpen ? styles.boxOpen : ''}` :
            
           ` ${styles.formGroup} ${destinationOpen ? styles.boxOpen2 : ''}`
        
                } ref={destinationInputRef}>
                 {props.type === 'update' && !destinationOpen &&
                     <p className={styles.updateP}>Destination</p>
                }
                 {/* The label belongs above the box - underneath it reads as a
                     caption for the next field instead of a name for this one */}
                 {props.type === 'create' && !destinationOpen &&
                     <p className={styles.fieldLabel}>Destination</p>
                }
                <div className={
                    props.type === 'create' ?
                    destinationOpen ? styles.destinationHolderOpen : styles.destinationHolder
                    :
                    destinationOpen ? styles.destinationHolderOpen2 : styles.updateStyleForm
                    } onClick={() => setDestinationOpen(true)} style={destinationOpen ? { height: 'fit-contant' } : {}}>
                    {!destinationOpen && (
                        props.destination
                            ? props.destination
                             : ''
                    )}

                    {destinationOpen && <>
                        <DestinationSuggestions suggestions={suggestions} setSuggestions={setSuggestions} setDestination={props.setDestination} destination={props.destination} setDestinationOpen={setDestinationOpen}
                            setCountry={props.setCountry} setCity={props.setCity} setNeighborhood={props.setNeighborhood} setState={props.setState} type={props.type}
                        />



                    </>}
                </div>


            </div>
          


            <div className={props.type === 'create'?
                styles.inputGroup
            :
            styles.formGroup}>
                {props.type === 'update'?
                     <p className={styles.updateP}>Select Trip Dates</p>: ''
                }
                {props.type === 'create' && !showCalendar &&
                     <p className={styles.fieldLabel}>Trip dates</p>
                }
            
                <div className={props.type === 'create' ?
                    showCalendar ? `${styles.destinationHolderOpen} ${styles.boxOpen}` : styles.destinationHolder
                    :
                    showCalendar ? `${styles.destinationHolderOpen} ${styles.boxOpen2}` : styles.updateStyleForm}
                    onClick={() => setShowCalendar(true)}
                    style={destinationOpen ? { height: 'fit-contant' } : {}}

                    id="date-range-input">  
                    {!showCalendar ?

                     !dateIsPlaceholder &&   props.dateRange[0]?.startDate && props.dateRange[0]?.endDate
                            ? `${formatDate(props.dateRange[0].startDate)} - ${formatDate(props.dateRange[0].endDate)}`
                            : props.type === 'create'
                                ? <span className={styles.fieldPlaceholder}>📅 Add your travel dates</span>
                                : ''
                        : ''}


                    {showCalendar && (
                        <div ref={dateInputRef} className={styles.calendar} onClick={(e) => e.stopPropagation()}>



                            <TripCalendar

                                setDateRange={props.setDateRange}
                                dateRange={props.dateRange}
                                setDateIsPlaceholder={setDateIsPlaceholder}
                            />

                            <button
                                type="button"
                                onClick={() => setShowCalendar(false)}
                                className={styles.calendarButton}
                            >
                                Done
                            </button>

                        </div>
                    )}
                </div>
                
            </div>

        </>
    )
}

